import { CSSTransition } from 'react-transition-group';
import { useEffect, useRef, useState } from 'react';
import './DraggableModal.css';

const DraggableModal = ({ show, setShow, children, zIndex, headerHeight, title, titleStyle , rounded}) => {
  const modalRef = useRef(null);
  const overlayRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [dragPosition, setDragPosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  useEffect(() => {
    if (show && modalRef.current) {
      setDragPosition({
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      });
    }
  }, [show]); // 모달이 열릴 때만 실행

  const startDrag = (e) => {
    setIsDragging(true);
    setStartPosition({
      x: e.clientX - dragPosition.x,
      y: e.clientY - dragPosition.y,
    });
  };

  const onDrag = (e) => {
    if (!isDragging) return;
    setDragPosition({
      x: e.clientX - startPosition.x,
      y: e.clientY - startPosition.y,
    });
  };

  const stopDrag = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', onDrag);
      document.addEventListener('mouseup', stopDrag);
    } else {
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', stopDrag);
    }

    return () => {
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', stopDrag);
    };
  }, [isDragging, onDrag]);

  return (
    <>
      {/* 오버레이 */}
      <CSSTransition
        in={show}
        nodeRef={overlayRef}
        timeout={300}
        classNames={'overlay'}
        unmountOnExit
      >
        <div
          ref={overlayRef}
          className="modal-overlay"
          style={{
            zIndex: zIndex !== undefined ? zIndex : 1000, // 외부 zIndex 또는 기본값
          }}
          onClick={() => setShow(false)} // 오버레이 클릭 시 모달 닫기
        />
      </CSSTransition>

      {/* 모달 */}
      <CSSTransition
        in={show}
        nodeRef={modalRef}
        timeout={300}
        classNames={'modal'}
        unmountOnExit
      >
        <div
          ref={modalRef}
          className="modal-content"
          style={{
            zIndex: zIndex !== undefined ? zIndex + 10 : 1010, // 오버레이보다 더 높은 zIndex
            left: `${dragPosition.x}px`,
            top: `${dragPosition.y}px`,
            ...(rounded ? { borderRadius: `${rounded}px` } : {})
          }}
          onClick={(e) => e.stopPropagation()} // 모달 내부 클릭 이벤트 중지
        >
          <div
            className="modal-header"
            style={{
              height: headerHeight !== undefined ? headerHeight : 50,
              cursor: isDragging ? 'grabbing' : 'grab',
            }}
            onMouseDown={startDrag}
          >
            <div className={`w-full h-full flex justify-center items-center ${titleStyle}`}>
              {title}
            </div>
            <div onClick={() => setShow(false)} className="absolute right-[10px] top-[50%] -translate-y-1/2 cursor-pointer p-[4px] rounded-lg hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </div>
            <div className={'absolute bottom-0 w-full px-[10px]'}>
              <div className={'bg-gray-200 h-[1px]'}></div>
            </div>
          </div>
          <div className={`max-h-[70vh] overflow-auto ${rounded ? `rounded-[${rounded}px]` : ''}`}>
            {children}
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default DraggableModal;
